import React from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useStore, useIsAdmin } from 'hooks';
import { CONSIGNEE_APPLICATION_STATUS, VALIDATION } from 'helpers/constants';
import { Button, ButtonClose } from 'components/ui/form';
import { Input, Select } from 'components/ui/formik';
import { UserConsigneeApplicationService } from 'services';
import styles from './consignee-applications.module.scss';

const ConsigneeApplicationsValidationSchema = Yup.object().shape({
  name: Yup.string()
    .max(...VALIDATION.MAX(255, VALIDATION.MAX_STRING))
    .required(...VALIDATION.REQUIRED),
  address: Yup.string()
    .max(...VALIDATION.MAX(255, VALIDATION.MAX_STRING))
    .required(...VALIDATION.REQUIRED),
  codeGd: Yup.string()
    .max(...VALIDATION.MAX(255, VALIDATION.MAX_STRING))
    .required(...VALIDATION.REQUIRED),
  status: Yup.number(),
});

const ConsigneeApplications = ({ edit, onClose }) => {
  const { setUser, setLoading } = useStore();
  const isAdmin = useIsAdmin();

  const initialValues = {
    name: edit ? edit.name : '',
    address: edit ? edit.address : '',
    codeGd: edit ? edit.codeGd : '',
  };

  if (isAdmin) {
    initialValues.status = edit ? edit.status : 0;
  }

  const onSubmit = async (values) => {
    const userConsigneeApplicationService = new UserConsigneeApplicationService({ setUser });
    setLoading(true);

    if (edit) {
      await userConsigneeApplicationService.updateConsigneeApplication(edit.id, { ...values });
    } else {
      await userConsigneeApplicationService.createConsigneeApplication({ ...values });
    }

    setLoading(false);
    onClose(true);
  };

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={ConsigneeApplicationsValidationSchema}
      onSubmit={onSubmit}
    >
      {({ handleSubmit }) => (
        <form onSubmit={handleSubmit} className={styles.consignee} autoComplete="off">
          <div className={styles.main}>
            <div className={styles.title}>
              Заявка на
              {edit ? ' изменение ' : ' создание '}
              грузополучателя
            </div>
            <div className={styles.fields}>
              <div className={styles.field}>
                <Input label="Наименование компании" name="name" placeholder="Введите наименование компании" />
              </div>
              <div className={styles.field}>
                <Input label="Адрес грузополучателя" name="address" placeholder="Введите полный адрес" />
              </div>
              <div className={styles.field}>
                <Input label="Ж/Д код грузополучателя" name="codeGd" placeholder="Введите Ж/Д код" />
              </div>
              {isAdmin ? (
                <Select label="Статус" name="status">
                  {[0, 1].map(value => (
                    <option value={value}>{CONSIGNEE_APPLICATION_STATUS.toString(value)}</option>
                  ))}
                </Select>
              ) : null}
            </div>
          </div>
          <div className={styles.buttons}>
            <div>
              <Button type="submit">{edit ? 'Изменить' : 'Добавить'}</Button>
            </div>
            <div>
              <ButtonClose onClick={() => onClose(false)}>{edit ? 'Закрыть' : 'Отменить'}</ButtonClose>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
};

export default ConsigneeApplications;
